const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const AddLicenses = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LICENSES_ADD_REQUEST":
      return { loading: true, error: false, data: [] };
    case "LICENSES_ADD_ERROR":
      return { loading: false, error: true, data: [] };
    case "LICENSES_ADD_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "LICENSES_ADD_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default AddLicenses;
